export default __webpack_public_path__ + "static/media/brand_07.b0a7da5e.png";